import type { DeckCard, DeckId } from "@/data/recovery-board-cards";

export type BoardCardRow = {
  id: string; deck: DeckId; sort_order: number; text: string; steps: string[] | null;
  reward: number | null; move: number | null; roll_again: boolean;
  link_to: string | null; link_label: string | null; active: boolean;
};

/** Editable cards (from Admin → Board Cards) become the same shape the game draws. */
export function toDeckCard(r: BoardCardRow): DeckCard {
  return {
    text: r.text,
    steps: r.steps?.length ? r.steps : undefined,
    reward: r.reward ?? undefined,
    effect: r.move || r.roll_again ? { move: r.move ?? undefined, rollAgain: r.roll_again || undefined } : undefined,
    link: r.link_to ? { to: r.link_to, label: r.link_label || "Explore" } : undefined,
  };
}
